module.exports = __webpack_public_path__ + "static/media/cl.cfda1dd1.svg";